import { Address } from 'viem';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { MAIN_TOKEN_ADDRESS } from 'modules/api/const';
import { getPublicClient } from 'modules/api/getPublicClient';
import {
  getAllowance,
  IGetAllowanceResult,
} from 'modules/api/methods/getAllowance';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

interface IGetAllowanceParams extends IConnectedActionParams {
  poolAddress: Address;
}

export const { useGetAllowanceQuery, useLazyGetAllowanceQuery } =
  api.injectEndpoints({
    endpoints: build => ({
      getAllowance: build.query<IGetAllowanceResult, IGetAllowanceParams>({
        queryFn: async ({ poolAddress }) => {
          const client = getPublicClient();
          const walletClient = getWalletClient();

          const result = await getAllowance(client, {
            userAddress: asAddress(walletClient.account?.address),
            spender: poolAddress,
            tokenAddress: MAIN_TOKEN_ADDRESS,
          });

          return { data: result };
        },
        providesTags: [cacheTags.allowance],
      }),
    }),
  });
